module.exports = __webpack_public_path__ + "static/media/bg_write_outline.80eeb1ee.svg";